import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "track", "display", "box"]
  static values = { value: { type: Number, default: 0 } }

  connect() {
    this.displayTarget.textContent = this.valueValue
    this.inputTarget.value = this.valueValue
    this.onDocumentClick = this.onDocumentClick.bind(this)
    document.addEventListener("click", this.onDocumentClick)
  }

  disconnect() {
    document.removeEventListener("click", this.onDocumentClick)
  }

  get isOpen() {
    return !this.trackTarget.classList.contains("hidden")
  }

  toggle() {
    this.isOpen ? this.close() : this.show()
  }

  show() {
    this.trackTarget.classList.remove("hidden")
    this.boxTarget.classList.add("active")
    this.highlight(this.valueValue)
    this.scrollToValue(this.valueValue)
  }

  close() {
    this.trackTarget.classList.add("hidden")
    this.boxTarget.classList.remove("active")
  }

  select(event) {
    event.stopPropagation()
    const value = Number(event.currentTarget.dataset.value)
    this.valueValue = value
    this.inputTarget.value = value
    this.displayTarget.textContent = value
    this.highlight(value)
    this.close()
  }

  highlight(value) {
    this.trackTarget.querySelectorAll(".score-picker-item").forEach((item) => {
      item.classList.toggle("active", Number(item.dataset.value) === value)
    })
  }

  scrollToValue(value) {
    const item = this.trackTarget.querySelector(`[data-value="${value}"]`)
    if (!item) return
    const track = this.trackTarget
    const offset = item.offsetTop - track.offsetHeight / 2 + item.offsetHeight / 2
    track.scrollTo({ top: offset, behavior: "instant" })
  }

  onDocumentClick(event) {
    if (!this.isOpen) return
    if (this.element.contains(event.target)) return
    this.close()
  }
}
